module.exports = __webpack_public_path__ + "img/default.2ca8a7a9.svg";